import React, { useState, useEffect } from "react";
import {
  PageHeader,
  DatePicker,
  Col,
  Button,
  Row,
  Select,
  notification,
} from "antd";

import { getAccesTokenApi } from "../../../api/auth";
import {
  generateReportCertificateApi,
  downloadReportCertificate,
} from "../../../api/supplier";
import { getDateDocument } from "../../../utils/functions";

import "./Logcertificate.scss";

const { Option } = Select;

export default function SupplierDetail(props) {
  const { match } = props;
  const [fechaIni, setFechaIni] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [Type, setType] = useState("");
  const [uploadingXls, setUploadingXls] = useState(false);
  const [uploadingPdf, setUploadingPdf] = useState(false);
  const token = getAccesTokenApi();

  const changeFIni = (value) => {
    setFechaIni(value);
  };

  const changeFFin = (value) => {
    setFechaFin(value);
  };
  const changeType = (value) => {
    setType(value);
  };

  const GenerateReportCertificateXls = () => {
    setUploadingXls(true);
    if ((fechaIni === "") & (fechaFin === "") & (Type === "")) {
      notification["error"]({
        message: "Debe seleccionar al menos un parámetro de consulta",
      });
      setUploadingXls(false);
    } else {
      generateReportCertificateApi(token, fechaIni, fechaFin, Type, 1).then(
        (response) => {
          if (response.estado === "OK") {
            //var today = getDateDocument();
            //const docDownload = `${response.resultado}?${today}`;
            downloadReportCertificate(response.resultado);
            setFechaIni("");
            setFechaFin("");
            setType("");
          } else {
            notification["error"]({
              message: "Error Generando Reporte: " + response.resultado,
            });
          }
          setUploadingXls(false);
        }
      );
    }
  };

  const GenerateReportCertificatePdf = () => {
    setUploadingPdf(true);
    if ((fechaIni === "") & (fechaFin === "") & (Type === "")) {
      notification["error"]({
        message: "Debe seleccionar al menos un parámetro de consulta",
      });
      setUploadingPdf(false);
    } else {
      generateReportCertificateApi(token, fechaIni, fechaFin, Type, 2).then(
        (response) => {
          if (response.estado === "OK") {
            //var today = getDateDocument();
            //const docDownload = `${response.resultado}?${today}`;
            downloadReportCertificate(response.resultado);
            setFechaIni("");
            setFechaFin("");
            setType("");
          } else {
            notification["error"]({
              message: "Error Generando Reporte: " + response.resultado,
            });
          }
          setUploadingPdf(false);
        }
      );
    }
  };

  return (
    <div className="supplier-detail">
      <PageHeader
        onBack={() => props.history.goBack()}
        title="Reporte Consulta de Certificados"
      />

      <div>
        <Row>
          <Col span={3} className="head">
            Seleccione fecha inicio:
          </Col>
          <Col span={5} className="name">
            <DatePicker onChange={changeFIni} value={fechaIni} />
          </Col>
          <Col span={3} className="head">
            Seleccione fecha fin:
          </Col>
          <Col span={5} className="name">
            <DatePicker onChange={changeFFin} value={fechaFin} />
          </Col>
          <Col span={3} className="head">
            Seleccione tipo de certificado:
          </Col>
          <Col span={5} className="name">
            <Select
              defaultValue=""
              style={{ width: 200 }}
              onChange={changeType}
              value={Type}
            >
              <Option value="">Seleccione Tipo...</Option>
              <Option value="IVA">IVA</Option>
              <Option value="ICA">ICA</Option>
              <Option value="retefuente">retefuente</Option>
            </Select>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={16} className="head"></Col>
          <Col span={4} className="head">
            <Button
              type="primary"
              icon="file-excel"
              onClick={GenerateReportCertificateXls}
              //disabled
              loading={uploadingXls}
              style={{ marginTop: 16, marginLeft: 10 }}
            >
              {uploadingXls ? "Generando Reporte..." : "Reporte Excel"}
            </Button>
          </Col>
          <Col span={4} className="head">
            <Button
              type="danger"
              icon="file-pdf"
              onClick={GenerateReportCertificatePdf}
              //disabled={disabled}
              loading={uploadingPdf}
              style={{ marginTop: 16, marginLeft: 10 }}
            >
              {uploadingPdf ? "Generando Reporte..." : "Reporte PDF"}
            </Button>
          </Col>
        </Row>
        
      </div>
    </div> 
  );
}
